import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Assets from 'app/configs/assetConfigs'
import clsx from 'clsx'
import * as R from 'ramda'
import RichTextDisplay from 'app/components/richTextEditor/RichTextDisplay'
import { FormattedMessage } from 'react-intl'
import moment from 'moment'
import { DATE_FORMAT_VOUCHER } from 'libs/dateUtils'

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: '300px',
    background: 'linear-gradient(to bottom, #73c3fe 3%, #00314b 100%)',
    borderRadius: '20px',
    '& .timeline': {
      maxWidth: '400px',
    },
  },
  promotionContent: {
    width: '100%',
    backgroundColor: '#fff',
    backgroundImage: `url('${Assets.dealAndPromotion.voucherWatermark}')`,
    backgroundSize: 'cover',
    backgroundRepeat: 'repeat',
    borderRadius: '20px',
    wordBreak: 'break-word',
  },
  promotionTitle: {
    width: '90%',
    fontSize: '3rem',
    fontFamily: 'Roboto',
    color: '#0073b1',
    padding: '2rem 0rem 1rem 0rem',
  },
  promotionDesc: {
    width: '80%',
    fontSize: '1.8rem',
    fontFamily: 'Roboto',
    color: '#000',
  },
  timeline: {
    width: '400px',
    minHeight: '400px',
  },
  textColorBlur: {
    fontSize: '12px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    color: '#247bcd',
  },
}))

export const PROMOTION_VIEW_MODE = {
  MODE_PREVIEW: 'PREVIEW',
  MODE_TIMELINE: 'TIMELINE',
}

export const getPromotionDetail = (notification) => {
  const endTime = R.has('voucher')(notification)
    ? R.path(['voucher', 'endDateTime'], notification)
    : R.prop('endTime', notification)

  const startTime = R.has('voucher')(notification)
    ? R.path(['voucher', 'startDateTime'], notification)
    : R.prop('startTime', notification)

  return {
    title: R.prop('voucherTitle', notification),
    desc: R.prop('voucherDescription', notification),
    startTime,
    endTime,
  }
}

const PromotionPreview = (props) => {
  const { mode, promotionData } = props
  const classes = useStyles()
  return (
    <div className="flex flex-col">
      <div
        className={clsx(
          'flex mx-12 p-20 h-full',
          { [classes.timeline]: mode === PROMOTION_VIEW_MODE.MODE_TIMELINE },
          classes.container,
        )}
      >
        <div
          className={clsx(
            'flex flex-1 flex-col w-full justify-center text-center',
            classes.promotionContent,
          )}
        >
          <div
            dir="auto"
            className={clsx(
              'mx-auto justify-center break-words',
              classes.promotionTitle,
            )}
          >
            <RichTextDisplay text={R.prop('title', promotionData)} />
          </div>
          <div
            dir="auto"
            className={clsx(
              'mx-auto pb-28 justify-center break-words',
              classes.promotionDesc,
            )}
          >
            <RichTextDisplay
              className="break-all"
              text={R.prop('desc', promotionData)}
            />
          </div>
        </div>
      </div>
      <div
        className={clsx(
          'w-full pt-16 pb-8 text-center p-2',

          classes.textColorBlur,
        )}
      >
        <label>
          <FormattedMessage
            id="notificationCard.voucherExpires.label"
            values={{
              start: moment(promotionData.startTime).format(
                DATE_FORMAT_VOUCHER,
              ),
              expire: moment(promotionData.endTime).format(DATE_FORMAT_VOUCHER),
            }}
          />
        </label>
      </div>
    </div>
  )
}

export default PromotionPreview
